// extracted by mini-css-extract-plugin
export default {"root":"EntityCard_root__MUFRS","hoverVisible":"EntityCard_hoverVisible__g8+eB"};